import {  useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';
import { FormLabel, FormValue } from './FormLabel';
import { Button  } from "reactstrap"
import { useEdit } from '../../Services/EditContext';
import { endpoints } from '../../utils/Constants';
import ErrorMessage from './ErrorMessage'
import LoadingAnimation from './LoadingAnimation';
import Selector from './Selector';
import { useFetchCached } from '../../Services/fetchApi';


const SelectCurrency = ({ id, label,noEdit }) => {
    const [selection, setSelection] = useState();
    const [options, setOptions] = useState([]);
    const { setFieldValue, values } = useFormikContext();
    const [edit] = useEdit();
    const [currencies, loading, error, refresh] = useFetchCached(endpoints.getCurrencies);
    const value = values[id]


    useEffect(() => {
        if (currencies instanceof Array) {
            const options = currencies.map(x => { return { label: x.value, value: x.value }; });
            setOptions(options);
        }
    }, [currencies]);
    useEffect(() => {
        if (options && value) {

            const list = value.split(',');
            const newOps = list.map(x => options.find(y => x === y.value));
            setSelection(newOps)
        }
    }, [value, options])

    const onSelectChange = val => {
       
            setFieldValue(id, val.value)
   
    }
    return <React.Fragment>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>
        {edit && !noEdit ? <Selector id={id} onChange={onSelectChange} value={selection} options={options} /> : <FormValue>{value}</FormValue>}
        {loading ? <LoadingAnimation height={'20px'}/> : error ? <h3>Error<Button from onClick={refresh}>Retry</Button></h3> : null}
        <ErrorMessage name={id} />
    </React.Fragment>
};

export default SelectCurrency;